import { useCallback, useMemo, useState } from 'react';

import database from '@atom/components/common/svgIcons/database.svg';
import { Icon } from '@atom/mui';
import {
  AIChatToolIds,
  AIConversationalAnalyticsQueryResult,
} from '@atom/types/ai';

import ChatCodeBlock from '../../ChatCodeBlock';
import { useToolCalls } from '../../hooks/useToolCalls';
import { styles } from '../styles';
import { ChatAssistantMessageHookResponse } from '../types';

export const useShowQueryAction = (): ChatAssistantMessageHookResponse => {
  const [showQuery, setShowQuery] = useState(false);

  const conversationalAnalyticsQueries =
    useToolCalls<AIConversationalAnalyticsQueryResult>(
      AIChatToolIds.QUERY_CONVERSATIONAL_ANALYTICS,
    ).filter(result => !result.isError);

  const queries = conversationalAnalyticsQueries
    .map(({ result }) => result?.sql)
    .filter(sql => !!sql);

  const handleOpen = useCallback(() => {
    setShowQuery(true);
  }, []);

  const handleClose = useCallback(() => {
    setShowQuery(false);
  }, []);

  return useMemo<ChatAssistantMessageHookResponse>(
    () => ({
      available: !!queries.length && !showQuery,
      type: 'menu',
      ui: [
        {
          icon: (
            <Icon style={styles.menuItemIcon}>
              <img src={database} />
            </Icon>
          ),
          copy: 'Show Query',
          onClick: handleOpen,
        },
      ],
      content:
        showQuery && queries.length > 0
          ? queries.map(query => (
              <ChatCodeBlock
                code={query}
                onClose={handleClose}
                closeText="Hide Query"
              />
            ))
          : null,
    }),
    [queries, showQuery, handleOpen, handleClose],
  );
};
